import { Select } from "antd";
import { useCommissionGroupSelectOptions } from "components/UI/Selects/CommissionGroupSelectSearchable/useCommissionGroupSelectOptions.ts";
import {
    SearchableSelect,
    SearchableSelectWrapperProps,
} from "components/UI/Selects/SearchableSelect/SearchableSelect.tsx";
import { usePaldockTranslation } from "hooks/usePaldockTranslation.tsx";
import { COMMISSION_GROUP_USER_GROUP } from "localConstants.ts";
import { useMemo } from "react";

interface CommissionGroupSelectSearchableProps extends SearchableSelectWrapperProps {
    withDefaultUserGroup?: boolean;
}

export const CommissionGroupSelectSearchable = ({
    withDefaultUserGroup = false,
    value,
    ...props
}: CommissionGroupSelectSearchableProps) => {
    const { t: tGeneral } = usePaldockTranslation("general");
    const { t: tCommon } = usePaldockTranslation("common");
    const hookResult = useCommissionGroupSelectOptions();

    const extendedHookResult = useMemo(() => {
        if (!withDefaultUserGroup) {
            return hookResult;
        }
        return {
            ...hookResult,
            options: [
                { label: tGeneral("default_user_group"), value: COMMISSION_GROUP_USER_GROUP },
                ...hookResult.options,
            ],
        };
    }, [hookResult, withDefaultUserGroup, tGeneral]);

    if (hookResult.loading && !hookResult.options.length) {
        // Don't pass value while loading to prevent showing raw UUIDs
        return (
            <Select
                size={props.size ?? "middle"}
                style={props.style}
                className={props.className}
                mode={props.mode}
                variant={props.variant}
                placeholder={tCommon("loading")}
                loading
                disabled
            />
        );
    }

    return (
        <SearchableSelect
            hookResult={extendedHookResult}
            translationNamespace="forms.general-fields.commission_group"
            {...props}
            value={value}
            size={props.size ?? "middle"}
        />
    );
};
